<!--
/**
 * DjAbnormalTab.vue - 异常话单 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的异常话单查询页面，
 * 用于查询号码的异常通话记录（异常话单），支持按代理商、企业、
 * 号码、时间范围等条件筛选，帮助发现异常使用行为。
 *
 * 【主要功能】
 * 1. 异常话单查询 - 按代理商、企业、号码、时间范围等条件查询异常话单
 * 2. 时间范围筛选 - 支持选择开始和结束日期进行筛选
 *
 * 【权限要求】
 * - 管理员 (isAdmin)：可按代理商筛选
 * - 普通用户：只能查看自己企业下的数据
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 代理商下拉选择框（仅管理员可见） -->
      <el-select size="small" @change="onAgentChange" v-if="isAdmin" v-model="query10.agentId" filterable
                 clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
        <el-option v-for="item in agents" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 企业下拉选择框 -->
      <el-select size="small" style="width: 260px" v-model="query10.companyId" @change="onCompanyChange"
                 filterable clearable placeholder="企业" class="handle-select mr10">
        <el-option v-for="item in companys" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query10.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 日期范围选择器 -->
      <el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" class="m_l_10"
                 @click="getdxtErrRecord">搜索
      </el-button>
    </div>

    <!-- ========== 异常话单表格 ========== -->
    <el-table :data="tableData10" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 代理商名称 -->
      <el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
      <!-- 企业名称 -->
      <el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
      <!-- 主叫手机号 -->
      <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
      <!-- 被叫号码 -->
      <el-table-column prop="phoneNumber" label="被叫号码" align="center"></el-table-column>
      <!-- 通话时间 -->
      <el-table-column prop="time" label="时间" align="center"></el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query10.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query10.pageSize" :total="pageTotal10" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 异常话单 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - fetchCompanyByAgentId：根据代理商ID获取企业列表
 * - fetchDefaultCompanies：获取默认企业列表
 * - dxtErrRecord：查询异常话单记录
 */
import {
  fetchCompanyByAgentId,
  fetchDefaultCompanies
} from '../../../api/companyIndex';
import {
  dxtErrRecord
} from '../../../api/dijia.js';

export default {
  name: 'DjAbnormalTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - isAdmin：是否为管理员（控制代理商筛选是否显示）
   * - agents：代理商列表
   */
  props: {
    theme: { type: String, default: '' },
    isAdmin: { type: Boolean, default: false },
    agents: { type: Array, default: () => [] },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      companys: [],             // 企业列表
      timeArr: [],              // 日期范围数组 [开始日期, 结束日期]
      query10: {                // 查询参数
        companyId: '',          // 企业ID
        agentId: '',            // 代理商ID
        userId: localStorage.getItem('user'),
        phone: '',              // 手机号
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
        subAgentId: '',         // 子代理ID
      },
      tableData10: [],          // 异常话单记录列表
      pageTotal10: 0,           // 总条数
    };
  },

  /**
   * 组件创建时的生命周期钩子
   * 1. 初始化企业列表
   * 2. 设置默认时间范围（当天）
   * 3. 查询异常话单记录
   */
  created() {
    this.initCompanies();
    this.getTime();
    this.getdxtErrRecord();
  },

  methods: {
    /**
     * initCompanies - 初始化企业列表
     */
    initCompanies() {
      let data = {
        currentUserId: localStorage.getItem('user'),
        subAgentId: ''
      };
      fetchDefaultCompanies(data).then(res => {
        if (res?.code === 200) {
          this.companys = res.data;
        }
      });
    },

    /**
     * onAgentChange - 代理商选择变化回调
     * @param {string} agentId - 选中的代理商ID
     */
    onAgentChange(agentId) {
      this.query10.agentId = agentId;
      this.query10.companyId = '';
      if (agentId) {
        let data = {
          subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
          agentId: agentId
        };
        fetchCompanyByAgentId(data).then(res => {
          this.companys = res.data;
        });
      } else {
        this.initCompanies();
      }
    },

    /** onCompanyChange - 企业选择变化回调（暂未实现） */
    onCompanyChange() {},

    /**
     * toDateTimeStr - 将Date对象转为 "YYYY-MM-DD" 格式字符串
     * @param {Date} date - 日期对象
     * @returns {string} 格式化后的日期字符串
     */
    toDateTimeStr(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m < 10) { m = '0' + m; }
      if (d < 10) { d = '0' + d; }
      return y + '-' + m + '-' + d;
    },

    /**
     * getTime - 初始化默认时间范围
     * 将时间范围设置为当天（开始和结束都是今天）
     */
    getTime() {
      let startTime = new Date(new Date());
      let endTime = new Date();
      this.timeArr.push(startTime);
      this.timeArr.push(endTime);
    },

    /**
     * getdxtErrRecord - 查询异常话单记录
     * 将日期范围格式化后提交查询
     */
    getdxtErrRecord() {
      this.loading = true;
      this.tableData10 = [];
      // 处理日期范围：如果为空则清空开始/结束时间
      if (this.timeArr === null) {
        this.query10.startTime = '';
        this.query10.endTime = '';
      } else {
        let startTime = this.toDateTimeStr(this.timeArr[0]);
        let endTime = this.toDateTimeStr(this.timeArr[1]);
        this.query10.startTime = startTime;
        this.query10.endTime = endTime;
      }
      dxtErrRecord(this.query10).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData10 = res.data.list;
          this.pageTotal10 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query10.pageIndex = val;
      this.getdxtErrRecord();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query10.pageSize = val;
      this.query10.pageIndex = 1;
      this.getdxtErrRecord();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
